import React from 'react';
import SwitchRoutes from '../../routes';
import { BrowserRouter, Link } from 'react-router-dom';

const anoAtual = new Date().getFullYear();

const App = () => (
    <React.StrictMode>
        <BrowserRouter basename={process.env.PUBLIC_URL}>
            <main className="f-main h-100 w-100">
                <nav className="f-header navbar-theme navbar navbar-expand f-header__sem-menu ">
                    <h3 className="logo">
                        <Link to="/" className="logo__link" rel="home">
                            <img className="logo__img" src="./furglogo.png" alt="Universidade Federal do Rio Grande - FURG" />
                            <span className="logo__desc">
                                Universidade <br /> Federal do Rio Grande
                            </span>
                        </Link>
                    </h3>
                </nav>

                <SwitchRoutes />

                <footer className="f-footer" role="contentinfo">
                    <div className="container-fluid f-footer__center">
                        <div className="f-footer__center">
                            <p className="f-footer__text">
                                <small className="text-muted">© {anoAtual} Centro de Gestão de Tecnologia da Informação</small>
                            </p>
                        </div>
                    </div>
                </footer>
            </main>
        </BrowserRouter>
    </React.StrictMode>
);

export default App;
